// extracted by mini-css-extract-plugin
module.exports = {"container":"iR","content":"iS","title":"iT","description":"iU","buttonWrapper":"iV"};